//Libs
import React from 'react';
import PropTypes from 'prop-types';
//Componentes material
import TableCell from '@material-ui/core/TableCell';
import Typography from '@material-ui/core/Typography';
import TableRow from '@material-ui/core/TableRow';
import { withStyles } from '@material-ui/core';
//Componentes
import Imagem from '../Imagem';
//Models
import AvaliacaoResposta from '../../models/AvaliacaoResposta';
//Estilos
import ResultadoStyle from '../../styles/ResultadoStyle';

/**
 * Renderiza a imagem ou uma mensagem informando que a mesma não foi informada
 * @param {String} imagem Url da imagem a ser renderizada
 * @param {Object} classes Classes CSS do componente
 * @return {Object} Retorna o componente de imagem ou uma mensagem
 */
function renderizarImagem(imagem, classes) {
    if (imagem)
        return (<Imagem alt="Resposta para questão do tipo imagem" src={imagem} />);
    else
        return (<Typography className={classes.texto} >A imagem não foi informada</Typography>);
}

/**
 * Renderiza as respostas do tipo foto, comparando as duas quando forem informadas
 * @param {Object} props
 * @param {Array<AvaliacaoResposta>} props.respostas Dados das respostas a serem exibidas
 * @param {Object} props.classes Classes CSS do componente
 */
function ResultadoQuestaoFoto({ respostas, classes }) {
    if (respostas.length === 0) return 'Nenhuma resposta encontrada';

    return (
        <TableRow>
            {
                respostas.map(resposta => (
                    <TableCell key={resposta.id}>{renderizarImagem(resposta.resposta, classes)}</TableCell>
                ))
            }
        </TableRow>
    );
}

ResultadoQuestaoFoto.propTypes = {
    /** Dados das respostas a serem exibidas */
    respostas: PropTypes.arrayOf(PropTypes.instanceOf(AvaliacaoResposta)).isRequired,
    /** Estilos do componente */
    classes: PropTypes.object
};

export default withStyles(ResultadoStyle)(ResultadoQuestaoFoto);